import { PropertyManagementSystem } from "shared/types/partner";

const MANUAL_ENROLLMENT_DISABLED_PMS = new Set<PropertyManagementSystem>([
  PropertyManagementSystem.Buildium,
  PropertyManagementSystem.Rentvine,
  PropertyManagementSystem.Quext,
  PropertyManagementSystem.Entrata,
  PropertyManagementSystem.RentManager,
  PropertyManagementSystem.Resman,
  PropertyManagementSystem.Yardi
]);

export const isManualEnrollmentDisabledForPms = (
  pms?: PropertyManagementSystem | ""
) => {
  if (!pms) return false;
  return MANUAL_ENROLLMENT_DISABLED_PMS.has(pms as PropertyManagementSystem);
};
